import React from "react";
import moment from "moment";
import DatePicker from "../Forms/DatePicker/DatePicker.tsx";
import { AnnexData } from "../../types/annex.ts";
import SelectGroup from "../Forms/SelectGroup/SelectGroup.tsx";
import SectionHeader from "../SectionHeader/SectionHeader.tsx";
import { inputClass, labelClass } from "../../constants/formStyles";

interface SumsAndDatesFormProps {
  policyEndDate: string;
  annexData: AnnexData;
  paymentAccounts: { [key: string]: string };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  saveAnnexData: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const AnnexSumsAndDatesForm: React.FC<SumsAndDatesFormProps> = ({
  policyEndDate,
  annexData,
  handleChange,
  saveAnnexData,
  paymentAccounts,
}) => {
  return (
    <fieldset className="border-stroke dark:border-strokedark shadow-default dark:bg-boxdark mt-2 rounded-sm border bg-white">
      <SectionHeader title="Суми и дати" />

      <div className="p-3 pt-1">
        <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
          <div>
            <label className={labelClass}>Застрахователна сума</label>
            <input
              name="insuredSum"
              type="text"
              onChange={handleChange}
              value={annexData?.insuredSum || "0"}
              className={inputClass}
            />
          </div>
          <div>
            <label className={labelClass}>Застрахователна премия</label>
            <input
              name="policySum"
              type="text"
              onChange={handleChange}
              value={annexData?.policySum || "0"}
              className={inputClass}
            />
          </div>
          <div>
            <label className={labelClass}>Сметки</label>
            <SelectGroup
              options={
                Object.keys(paymentAccounts).length > 0
                  ? paymentAccounts
                  : annexData?.paymentAccount
                  ? { [annexData.paymentAccount]: annexData.paymentAccount }
                  : {}
              }
              value={annexData?.paymentAccount}
              placeholder={
                Object.keys(paymentAccounts).length === 0
                  ? annexData?.paymentAccount || "Няма налични сметки"
                  : annexData?.paymentAccount
              }
              onChange={(selectedValue: string) => {
                handleChange({
                  target: { name: "paymentAccount", value: selectedValue },
                } as React.ChangeEvent<HTMLInputElement>);
              }}
            />
          </div>
          <div>
            <label className={labelClass}>Други данни за добавък</label>
            <input
              data-no-decimal-guard=""
              name="policyAdditionalData"
              type="text"
              onChange={handleChange}
              value={annexData.policyAdditionalData || ""}
              className={inputClass}
            />
          </div>

          <div>
            <DatePicker
              label="Дата на сключване"
              onChange={handleChange}
              value={annexData?.contractDate || moment().format("DD/MM/YYYY")}
              name="contractDate"
            />
          </div>
          <div>
            <DatePicker
              label="Начална дата"
              onChange={handleChange}
              value={
                annexData?.startDate ||
                moment().add(1, "days").format("DD/MM/YYYY")
              }
              name="startDate"
            />
          </div>
          <div>
            <DatePicker
              label="Крайна дата"
              onChange={handleChange}
              value={
                policyEndDate ||
                moment().add(1, "year").subtract(1, "days").format("DD/MM/YYYY")
              }
              name="endDate"
            />
          </div>
          <div>
            <DatePicker
              label="Дата на отчитане"
              onChange={handleChange}
              value={
                annexData?.reportDate ||
                moment(annexData.reportDate).format("DD/MM/YYYY") ||
                moment().format("DD/MM/YYYY")
              }
              name="reportDate"
            />
          </div>
        </div>

        <div className="mt-3 flex justify-center">
          <button
            onClick={(e) => {
              e.preventDefault();
              saveAnnexData(e);
            }}
            className="bg-primary w-1/6 justify-center rounded px-3 py-1.5 text-xs font-medium text-white hover:bg-opacity-90"
          >
            Запис
          </button>
        </div>
      </div>
    </fieldset>
  );
};

export default AnnexSumsAndDatesForm;
